'use strict';

module.exports = /*@ngInject*/
function(
    ApiConfig,
    InterceptorService
) {
    return {
        getCategoryData: function(categoryId) {
            return InterceptorService.cachedGet(ApiConfig.category + '/' + categoryId);
        }
    };
};
